import React, { useState } from 'react';
import '../styles/Faqs.css';
import { baseUrl } from '../config';



const FAQs = () => {
  // List of FAQs
  const [faqs, setFaqs] = useState([
    {
      question: 'How can I contact customer support?',
      answer: 'You can contact customer support via email at support@example.com or call us at (123) 456-7890.',
      isOpen: false,
    },
    {
      question: 'What is your return policy?',
      answer: 'We offer a 30-day return policy for all products. Please ensure the items are in their original condition.',
      isOpen: false,
    },
    {
      question: 'Do you offer international shipping?',
      answer: 'Yes, we ship internationally. Additional shipping charges may apply depending on the location.',
      isOpen: false,
    },
  ]);

  // Form input state
  const [newQuestion, setNewQuestion] = useState('');

  // Toggle the answer visibility
  const toggleFAQ = (index) => {
    setFaqs(faqs.map((faq, i) => {
      if (i === index) {
        faq.isOpen = !faq.isOpen;
      } else {
        faq.isOpen = false;
      }
      return faq;
    }));
  };

  // Handle form submission (just capture question without showing it)
  const handleSubmit = (e) => {
    e.preventDefault();
    if (newQuestion) {
      // You can store or process the question here (send it to a server, etc.)
      setNewQuestion(''); // Clear the input after submission
    }
  };

  return (
    <div className="faqs-container">
      <h2>Frequently Asked Questions</h2>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${faq.isOpen ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{faq.question}</h3>
              <span>{faq.isOpen ? '-' : '+'}</span>
            </div>
            {faq.isOpen && <div className="faq-answer"><p>{faq.answer}</p></div>}
          </div>
        ))}
      </div>

      {/* Section to submit a new question */}
      <div className="add-faq">
        <h3>Submit a Question</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Question:</label>
            <textarea
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
              required
            />
          </div>
          <button type="submit">Submit Question</button>
        </form>
      </div>
    </div>
  );
};

export default FAQs;

